<section class="wrap">
 
  <div class="carousel">
    <button
      class="nav prev"
      type="button"
      (click)="prev()"
      aria-label="Anterior"
    >
      ‹
    </button>

    <div
      #track
      class="track"
      (scroll)="onScroll()"
      (pointerdown)="onPointerDown($event)"
      (pointermove)="onPointerMove($event)"
      (pointerup)="onPointerUp()"
      (pointercancel)="onPointerUp()"
    >
      <a
        class="card"
        href="{{ item.link }}"
        target="_blank"
        rel="noopener noreferrer"
        class="card"
        *ngFor="let item of items; let i = index"
        target="_blank"
        [attr.aria-label]="item.title || 'TikTok ' + (i + 1)"
      >
        <img
          class="thumb"
          [src]="item.img"
          [alt]="item.title || 'TikTok'"
          loading="lazy"
          draggable="false"
        />

        <div class="overlay">
          <div class="pill">TikTok</div>
          <div class="meta" *ngIf="item.title">
            <div class="t">{{ item.title }}</div>
          </div>
          <div class="play" aria-hidden="true">▶</div>
        </div>
    </a>
    </div>

    <button
      class="nav next"
      type="button"
      (click)="next()"
      aria-label="Siguiente"
    >
      ›
    </button>
  </div>

  <div class="dots" *ngIf="showDots && pages.length > 1">
    <button
      type="button"
      class="dot"
      *ngFor="let _ of pages; let p = index"
      [class.active]="p === pageIndex"
      (click)="goToPage(p)"
      [attr.aria-label]="'Ir a página ' + (p + 1)"
    ></button>
  </div>
</section>
